<template>
  <m-pageframe :title="page_title">
    <v-container
      fluid
      class="py-5 mb-10"
    >
      <v-row>
        <v-col cols="12">
          <!-- Header Section -->
          <v-row class="mb-4">
            <v-col cols="10">
              <h1 class="text-h4 font-weight-bold mb-1">{{ heading }}</h1>
              <p
                v-if="description"
                class="text-body-2 text--secondary mb-0"
              >
                {{ description }}
              </p>
            </v-col>
            
            <v-col
              cols="2"
              class="d-flex align-center justify-end"
            >
              <slot name="header-actions" />
              <v-menu
                bottom
                offset-y
                left
              >
                <template #activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <slot name="menu-items" />
                </v-list>
              </v-menu>
            </v-col>
          </v-row>

          <!-- Filter Bar -->
          <sticky-bar
            class="shaded-light mb-0 pa-0"
            :outlined="false"
            :static_breakpoint="1120"
            dense
          >
            <div class="filter-wrapper">
              <v-text-field
                class="search-input flex-grow-1"
                autocomplete="off"
                :label="search_label"
                prepend-inner-icon="mdi-magnify"
                :value="search_text"
                clearable
                hide-details
                dense
                outlined
                @input="$emit('update:search_text', $event)"
              />

              <slot name="filters" />

              <v-spacer />

              <slot name="filter-actions" />

              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-btn
                    :loading="loading"
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="$emit('refresh')"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Refresh data</span>
              </v-tooltip>
            </div>
          </sticky-bar>

          <slot name="table" />

          <slot name="footer-notes" />
        </v-col>
      </v-row>
    </v-container>

    <slot name="dialogs" />
  </m-pageframe>
</template>

<script>
import StickyBar from '@/components/layouts/sticky-bar.vue';

export default {
  name: 'WidgetSubmissionsLayout',

  components: {
    StickyBar,
  },

  props: {
    page_title: {
      type: String,
      required: true,
    },
    heading: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    search_label: {
      type: String,
      default: 'Search',
    },
    search_text: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.enhanced-submissions-table) {
  .v-data-table__wrapper {
    border-radius: 8px;
  }

  tbody tr {
    transition: all 0.2s ease-in-out;
  }

  tbody tr:hover {
    background-color: rgba(var(--v-primary-base), 0.04) !important;
  }
}

.search-input {
  min-width: 280px;
}

.filter-wrapper {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  gap: 1rem;
}

@media (max-width: 1120px) {
  .filter-wrapper {
    flex-direction: column;
    align-items: stretch;
    overflow-x: auto;
    padding: 1rem 0.5rem;
  }
}

.status-chip {
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
